import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Img } from '../common'

const Cover = ({ author, title, hideHeaders }) => {
  const { t } = useTranslation()
  return (
    <>
      {!hideHeaders && (
        <Typography.Paragraph className="paragraph-sb">
          {t('Author.Details.BookCover')}
        </Typography.Paragraph>
      )}
      {!hideHeaders && (
        <div style={{ marginTop: '-10px', marginBottom: '15px' }}>
          {t('Author.Details.BookCoverInfo')}
        </div>
      )}
      <div className="cover">
        <Img src={'images/cover.webp'} alt={title} />
        <Typography.Paragraph className="author" ellipsis={{ rows: 1 }}>
          {author}
        </Typography.Paragraph>
        <Typography.Paragraph className="title" ellipsis={{ rows: 3 }}>
          {title}
        </Typography.Paragraph>
      </div>
    </>
  )
}

export default Cover
